<template>
  <canvas ref="canvas" :class="{
    'foregroundNetwork': this.type==='foreground',
    'backgroundNetwork': this.type==='background',
    'globeNetwork': this.type==='globe'
          }"></canvas>
</template>

<script>
  import {animateWhinNetwork} from "@/lib/networkAnimation"

  export default {
    name: "NetworkAnimation",
    props: [
      'type'
    ],
    mounted() {
      const canvasType = this.type;
      animateWhinNetwork(this.$refs.canvas, this.type, window.innerWidth, window.innerHeight);
    }
  }
</script>

<style>
.foregroundNetwork,
.globeNetwork {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
}
.backgroundNetwork {
	position: absolute;
  top: 0;
  left: 0;
	z-index: 0;
}
.globeNetwork {
	pointer-events: none;
	z-index: 997;
}
</style>